import { PureComponent } from 'react';
import EventBoundaryPopover from './EventBoundaryPopover';
import LinkForm from './LinkForm';
import { encodeUrl, ensureUrlHasProtocol } from '../utils/libUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const isNotDefined = value => value === undefined || value === null;
export class ImageLinkPopoverComponentClass extends PureComponent {
  constructor(props) {
    super(props);
    this.getCleanState = () => {
      let {
        url,
        isTargetBlank,
        isNoFollow
      } = this.props;
      if (isNotDefined(url)) {
        url = '';
      }
      if (isNotDefined(isTargetBlank)) {
        isTargetBlank = true;
      }
      if (isNotDefined(isNoFollow)) {
        isNoFollow = false;
      }
      return {
        url,
        isTargetBlank,
        isNoFollow
      };
    };
    this.clearInput = () => {
      this.setState(this.getCleanState());
    };
    this.togglePopover = e => {
      const {
        open,
        onOpen,
        onCancel
      } = this.props;
      this.clearInput();

      // lifted from image componenet
      // without these two calls, the click will propagate up the chain
      // causing many unintended side effects
      e.preventDefault();
      e.stopPropagation();
      if (open) {
        onCancel();
      } else {
        onOpen();
      }
    };
    this.handleChange = state => {
      this.setState(state);
    };
    this.handleConfirm = () => {
      const {
        url,
        isTargetBlank,
        isNoFollow
      } = this.state;
      const urlWithProtocol = ensureUrlHasProtocol(url);
      const encodedUrl = encodeUrl(urlWithProtocol);
      this.props.onConfirm({
        url: encodedUrl,
        isTargetBlank,
        isNoFollow
      });
    };
    this.handleCancel = () => {
      this.clearInput();
      this.props.onCancel();
    };
    this.handleRemove = () => {
      this.props.onRemove();
      this.props.onCancel();
    };
    this.renderPopoverContent = () => {
      const {
        url,
        isTargetBlank,
        isNoFollow
      } = this.state;
      return /*#__PURE__*/_jsx(LinkForm, {
        isNew: false,
        url: url,
        isTargetBlank: isTargetBlank,
        isNoFollow: isNoFollow,
        showText: false,
        onChange: this.handleChange,
        onConfirm: this.handleConfirm,
        onCancel: this.handleCancel,
        onRemove: this.handleRemove
      });
    };
    this.state = this.getCleanState();
  }
}
ImageLinkPopoverComponentClass.displayName = 'ImageLinkPopover';
ImageLinkPopoverComponentClass.defaultProps = {};
export default (Child => {
  return class extends ImageLinkPopoverComponentClass {
    render() {
      const {
        open,
        onOpenChange
      } = this.props;
      return /*#__PURE__*/_jsx(EventBoundaryPopover, {
        open: open,
        onOpenChange: onOpenChange,
        Content: this.renderPopoverContent,
        closeOnOutsideClick: true,
        animateOnToggle: false,
        children: /*#__PURE__*/_jsx(Child, Object.assign({}, this.props, {
          togglePopover: this.togglePopover
        }))
      });
    }
  };
});